export const CONSENT_STORAGE_KEY = 'burnout-consent-v1';
export const CONSENT_MAX_AGE_MS = 180 * 24 * 60 * 60 * 1000;

export type ConsentChoice = 'accepted' | 'rejected';
export type ConsentRecord = { choice: ConsentChoice; timestamp: number };
export type StorageLike = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>;

function isChoice(value: unknown): value is ConsentChoice {
  return value === 'accepted' || value === 'rejected';
}

export function parseConsent(value: string | null, now = Date.now()): ConsentRecord | null {
  if (!value) return null;
  try {
    const parsed: unknown = JSON.parse(value);
    if (!parsed || typeof parsed !== 'object') return null;
    const record = parsed as Record<string, unknown>;
    const timestamp = record.timestamp;
    if (!isChoice(record.choice) || typeof timestamp !== 'number' || !Number.isFinite(timestamp) || timestamp <= 0 || timestamp > now || now - timestamp > CONSENT_MAX_AGE_MS) return null;
    return { choice: record.choice, timestamp };
  } catch {
    return null;
  }
}

export function readConsent(storage: StorageLike | null | undefined, now = Date.now()): ConsentRecord | null {
  if (!storage) return null;
  try {
    return parseConsent(storage.getItem(CONSENT_STORAGE_KEY), now);
  } catch {
    return null;
  }
}

export function saveConsent(storage: StorageLike | null | undefined, choice: ConsentChoice, timestamp = Date.now()): ConsentRecord {
  const record = { choice, timestamp };
  try { storage?.setItem(CONSENT_STORAGE_KEY, JSON.stringify(record)); } catch { /* memory-only fallback */ }
  return record;
}

export function clearConsent(storage: StorageLike | null | undefined): void {
  try { storage?.removeItem(CONSENT_STORAGE_KEY); } catch { /* storage may be blocked */ }
}
